import { format } from "date-fns";
import { enGB, nlBE, fr } from "date-fns/locale";

const locales = {
    en: enGB,
    nl: nlBE,
    fr,
};

export default function localizedFormat(
    date,
    formatString = "PPP p",
    locale = "en"
) {
    // Make sure there are no more unescaped characters in the format string
    return format(date, String(formatString), {
        locale: locales[locale] ?? locales.en,
    });
}
